const title = [
    {
        title: 'Channel',
        key: 'ChannelNameCH',
        width: '10%'
    },
    {
        title: 'Channel Order #',
        key: 'ChannelOrderID',
        width: '18%'
    },
    {
        title: 'Tracking # ',
        key: 'TrackingNumberCH',
        width: '13%'
    },
    {
        title: 'Ship Date',
        key: 'ShipDateDT',
        width: '10%'
    },
    {
        title: 'Package Info',
        key: 'PackageInfo',
        width: '10%'
    },
    {
        title: 'Country',
        key: 'ConsigneeCountryCH',
        width: '8%'
    },
    {
        title: 'Ship To Name',
        key: 'ConsigneeNameCH',
        width: '13%'
    },
    {
        title: 'Status',
        key: 'StatusCH',
        width: '16%'
    },
]
export default title



// WEBPACK FOOTER //
// ./src/containers/shipments/components/box-utility/title.js